import React from "react";
import { BaseModal } from "./BaseModal";
import { useStore } from "../../stores/store";
import { ModalKeys } from "../../interfaces/config";

export default function NoRecordsFoundModal() {
  const { isActive, deactivateTool } = useStore();
  return (
    <BaseModal
      active={isActive(ModalKeys.NO_RESULTS_FOUND)}
      title="No Results Found"
    >
      <div className="p-3 font-helvetica text-sm">
        <p>Your search has returned no results. Please try again.</p>
      </div>
      <div className="bg-[#f5f5f5] border-t border-[#ddd] w-full text-right p-1">
        <button
          onClick={() => deactivateTool(ModalKeys.NO_RESULTS_FOUND)}
          className="btn-athena btn-sm mr-1"
        >
          OK
        </button>
      </div>
    </BaseModal>
  );
}
